<h2 class="text-navy" mat-dialog-title>
  <span>{{ 'hcp-layout.nav-finances-h1' | translate }}</span>
</h2>
<button
  class="close-button z-notifier"
  color="primary"
  mat-dialog-close
  mat-button
  aria-label="dialog close icon"
>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  <div class="py-8">
    <div class="md:flex md:items-stretch">
      <div class="flex-grow">
        <div class="p-4 rounded-2xl bg-light-gray md:p-8 md:rounded-4xl mt-8">
          <div class="flex flex-col items-start justify-between md:flex-row md:items-center">
            <div *ngIf="isTransitioning" class="w-full flex items-center justify-center h-full">
              <app-spinner class="inline-block ml-4 h-8 w-8"></app-spinner>
            </div>
            <div *ngIf="!isTransitioning" class="flex items-center justify-start">
              <app-image-render img="assets/svg/wallet.svg" class="w-14"></app-image-render>
              <div class="font-bold text-navy flex flex-col items-end justify-center">
                <p *ngIf="wallet" class="text-lg">
                  {{ _toMoney(wallet.amount) }} {{ currency ? currency.code : '' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="my-8">
      <app-global-dropdown
        (triggerEvent)="handlePeriodDropdownEvent($event)"
        [options]="optionPeriodDropdown"
        [pickValue]="optionPeriodDropdown[0]"
      ></app-global-dropdown>
    </div>
    <div *ngIf="!isTransitioning && transactions?.length === 0" class="w-full mt-8">
      <div class="flex flex-col justify-center h-full items-center content-center text-center">
        <img appImg  src="assets/images/transaction.png" class="w-36 grayscale" />
        <p class="my-8 text-gray text-lg font-bold md:text-2xl text-center">
          {{ 'hcp-home.no-transactions' | translate }}
        </p>
      </div>
    </div>
    <div class="ml-4 {{ isTransitioning ? 'opacity-50' : '' }}">
      <ol class="relative border-l border-gray-200 dark:border-gray-700">
        <div *ngFor="let t of transactions">
          <li *ngIf="t.type === transactionType.TOPUP" class="mb-8 ml-6">
            <span
              class="flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
            >
              <app-avatar
                [classNames]="'w-6 h-6'"
                [withFrame]="false"
                [src]="avatar | imageToUrl"
              ></app-avatar>
            </span>
            <div
              class="justify-between items-center p-4 bg-white rounded-lg border border-gray-200 shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600"
            >
              <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">{{
                _toLocaleDateTime(t.created_at)
              }}</time>
              <div class="text-sm font-normal text-gray-500 dark:text-gray-300">
                {{ 'hcp-home.credit-from-kimboCare' | translate }}
                <a class="font-semibold text-blue-600 dark:text-blue-500"
                  >{{ _toMoney(t.hc_amount) }} {{ currency.symbol }}</a
                >
                <span
                  class="bg-gray-100 text-gray-800 text-xs font-normal mr-2 px-2.5 py-0.5 rounded dark:bg-gray-600 dark:text-gray-300"
                  >(+{{ _toMoney(t.hc_amount) }} {{ currency.symbol }})</span
                >
              </div>
            </div>
          </li>
          <li *ngIf="t.type === transactionType.HEALTHCAREPACKAGEDEBIT" class="mb-8 ml-6">
            <span
              class="flex absolute -left-3 justify-center items-center w-6 h-6 bg-blue-200 rounded-full ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900"
            >
              <img appImg  class="rounded-full shadow-lg" [src]="avatar | imageToUrl" alt="avatar image" />
            </span>
            <div
              class="justify-between items-center p-4 bg-white rounded-lg border border-gray-200 shadow-sm sm:flex dark:bg-gray-700 dark:border-gray-600"
            >
              <time class="mb-1 text-xs font-normal text-gray-400 sm:order-last sm:mb-0">{{
                _toLocaleDateTime(t.created_at)
              }}</time>

              <div class="text-sm font-normal text-gray-500 lex dark:text-gray-300">
                {{ 'hcp-home.credit-from-treatments' | translate }}
                <a class="font-semibold text-blue-600 dark:text-blue-500"
                  >{{ _toMoney(t.hc_amount) }} {{ currency.symbol }}</a
                >
                <span
                  class="bg-gray-100 text-gray-800 text-xs font-normal mr-2 px-2.5 py-0.5 rounded dark:bg-gray-600 dark:text-gray-300"
                  >(-{{ _toMoney(t.hc_amount) }} {{ currency.symbol }})</span
                >
              </div>
            </div>
          </li>
        </div>
      </ol>
    </div>
  </div>
</mat-dialog-content>
